import { MRT_ColumnDef } from "material-react-table"
import { useMemo } from "react"
import { City, ISolicitudCanje, ISolicitudEvento, Province } from "../interfaces"
import { formatDate } from "../utils"

type SolicitudesCanjeEventoType = Partial<ISolicitudCanje> & Partial<ISolicitudEvento> & {
    provincia_data?: Province
    ciudad_data?: City
}

export const useTableColumnsMarketing = () => {

  const ColumnsSolicitudCanje = useMemo<MRT_ColumnDef<SolicitudesCanjeEventoType>[]>(() => [
    {
      accessorKey: 'identificacion',
      header: 'Identificación',
      size: 300,
    },
    {
      accessorKey: 'razon_social',
      header: 'Razón Social',
      size: 300,
    },
    {
      accessorKey: 'provincia',
      header: 'provincia',
      size: 200,
      Cell: ({ row }) => (
        row.original.provincia_data?.nombre||"N/A"
      )
    },
    {
      accessorKey: 'ciudad',
      header: 'ciudad',
      size: 200,
      Cell: ({ row }) => (
        row.original.ciudad_data?.nombre||"N/A"
      )
    },
    {
      accessorKey: 'coordenadas',
      header: 'coordenadas',
      size: 200,
    },
    {
      accessorKey: 'direccion',
      header: 'dirección',
      size: 400,
    },
    {
      accessorKey: 'servicio',
      header: 'servicio',
      size: 200,
    },
    {
      accessorKey: 'capacidad',
      header: 'capacidad',
      size: 200,
    },
    {
      accessorKey: 'nombre_contacto',
      header: 'Nombre de Contacto',
      size: 200,
    },
    {
      accessorKey: 'numero_contacto',
      header: 'Número de Contacto',
      size: 200,
    },
    {
      accessorKey: 'observacion_canje',
      header: 'Observación Canje',
      size: 400,
      Cell: ({ row }) => (
        row.original.observaciones?.observacion_canje||"N/A"
      )
    },
    {
      accessorKey: 'requiere_inspeccion',
      header: 'Requiere Inspección',
      size: 200,
      Cell: ({ row }) => (
        row.original.requiere_inspeccion?"SI":"NO"
      )
    },
    {
      accessorKey: 'requiere_cotizacion',
      header: 'Requiere Cotización',
      size: 200,
      Cell: ({ row }) => (
        row.original.requiere_cotizacion?"SI":"NO"
      )
    },
    {
      accessorKey: 'fecha_creacion',
      header: 'Fecha Creación',
      size: 200,
      Cell: ({ row }) => (
        formatDate(row.original.fecha_creacion!)
      )
    },


  ], [])


  const columnsSolicitudEvento = useMemo<MRT_ColumnDef<SolicitudesCanjeEventoType>[]>(() => [
    {
      accessorKey: 'nombre',
      header: 'Nombre Evento',
      size: 200,
    },
    {
      accessorKey: 'fecha_inicio',
      header: 'fecha inicio',
      size: 200,
      Cell: ({ row }) => (
        formatDate(row.original.fecha_inicio!)
      )
    },
    {
      accessorKey: 'fecha_fin',
      header: 'fecha fin',
      size: 200,
      Cell: ({ row }) => (
        formatDate(row.original.fecha_fin!)
      )
    },
    {
      accessorKey: 'responsable',
      header: 'responsable',
      size: 200,
    },
    {
      accessorKey: 'identificacion',
      header: 'identificacion',
      size: 200,
    },
    {
      accessorKey: 'servicio',
      header: 'servicio',
      size: 200,
    },
    {
      accessorKey: 'provincia',
      header: 'provincia',
      size: 200,
      Cell: ({ row }) => (
        row.original.provincia_data?.nombre||"N/A"
      )
    },
    {
      accessorKey: 'ciudad',
      header: 'ciudad',
      size: 200,
      Cell: ({ row }) => (
        row.original.ciudad_data?.nombre||"N/A"
      )
    },
    {
      accessorKey: 'coordenadas',
      header: 'coordenadas',
      size: 200,
    },
    {
      accessorKey: 'direccion',
      header: 'dirección',
      size: 400,
    },
    {
      accessorKey: 'capacidad',
      header: 'capacidad',
      size: 200,
    },
    {
      accessorKey: 'nombre_contacto',
      header: 'Nombre de Contacto',
      size: 200,
    },
    {
      accessorKey: 'numero_contacto',
      header: 'número contacto',
      size: 200,
    },
    {
      accessorKey: 'observacion_evento',
      header: 'Observación Evento',
      size: 400,
      Cell: ({ row }) => (
        row.original.observaciones?.observacion_evento||"N/A"
      )
    },
    {
      accessorKey: 'fecha_creacion',
      header: 'Fecha Creación',
      size: 200,
      Cell: ({ row }) => (
        formatDate(row.original.fecha_creacion!)
      )
    },

  ], [])

  return {
    ColumnsSolicitudCanje,
    columnsSolicitudEvento
  }
}